function normalizeMessage(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const message = value.trim()
  return message || null
}

function extractFromValidationErrors(value: unknown): string | null {
  if (!value) return null

  if (Array.isArray(value)) {
    for (const entry of value) {
      const message = normalizeMessage(entry) || extractFromValidationErrors(entry)
      if (message) return message
    }
    return null
  }

  if (typeof value === 'object') {
    for (const entry of Object.values(value as Record<string, unknown>)) {
      const message = normalizeMessage(entry) || extractFromValidationErrors(entry)
      if (message) return message
    }
  }

  return null
}

export function getApiMessage(source: unknown): string | null {
  const data = (source as { response?: { data?: unknown } } | null | undefined)?.response?.data ?? source
  if (!data) return null

  const directMessage = normalizeMessage(data)
  if (directMessage) return directMessage

  if (typeof data !== 'object') return null

  const record = data as Record<string, unknown>
  return normalizeMessage(record.message)
    || normalizeMessage(record.Message)
    || normalizeMessage(record.error)
    || normalizeMessage(record.Error)
    || normalizeMessage(record.detail)
    || normalizeMessage(record.Detail)
    || normalizeMessage(record.title)
    || normalizeMessage(record.Title)
    || extractFromValidationErrors(record.errors)
    || extractFromValidationErrors(record.Errors)
}
